<template>
  <v-container pa-0 fluid ref="container">
    <v-layout>
      <v-toolbar class="pa-0 ma-0 toolbar-padding" :class="{ 'toolbar-shadow': scrollY === 0 }"
                 color="white" flat fixed app>
        <v-btn icon @click="$router.go(-1)" class="pa-0">
          <v-icon size="32px" color="#a9a9af">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 class="display-2" style="margin-bottom: 2px">{{ title }}</h3>
      </v-toolbar>

      <v-flex xs12>
        <v-card tile class="pt-3 pb-4 mt-2 overflow-x-hidden card-shadow">

          <v-card-title primary-title class="pb-0 pt-1">
            <h1 class="display-4">{{ title }}</h1>
          </v-card-title>

          <v-card-title class="py-0">
            <v-layout row>
              <div style="flex-shrink: 0;">
                <span class="caption caption-strong" v-text="`${totalCount}개`"></span>
                <span class="caption" v-text="`의 ${name} 클래스가 있습니다.`"></span>
              </div>
            </v-layout>
          </v-card-title>

          <v-card-text class="ma-0 pt-4 pl-0 pr-0 pb-0">
            <v-progress-circular v-if="isLoading" indeterminate class="mb-4"></v-progress-circular>

            <v-container fluid grid-list-md class="py-0" v-else>
              <v-layout row wrap>
                <v-flex xs6 v-for="(product, index) of products" :key="index">
                  <ProductCard :alarms="product.alarms"
                               :idx="product.idx"
                               :title="product.title"
                               :subtitle="product.subtitle"
                               :publishedAt="product.published_at"
                               :status="product.status"
                               :thumbnail="product.thumbnail"
                               :bookmarks="product.bookmarks"
                               :subtitle_color="product.subtitle_color"
                               @bookmark="bookmarkProduct(product.idx)"
                               @alarm="alarmProduct(product.idx)" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapMutations } from 'vuex';
  import ProductCard from '@/components/ProductCard';

  export default {
    name: 'Products',
    components: { ProductCard },
    data () {
      return {
        isLoading: true,
        title: this.$route.name === 'EarlyBird' ? '얼리버드' : '신규 예정 클래스',
        name: this.$route.name === 'EarlyBird' ? '얼리버드' : '신규 예정',
        status: this.$route.name === 'EarlyBird' ? 'earlybird' : 'ready',
        time: new Date().getTime() / 1000,
        page: 1,
        maxPage: 2,
        totalCount: 0,
        products: [],
        scrollY: 0,
        bottom: true,
      };
    },
    created () {
      this.select();
      window.addEventListener('scroll', this.getScrollY);
    },
    destroyed () {
      window.removeEventListener('scroll', this.getScrollY);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (bottom && !oldBottom) {
          this.select();
        }
      },
    },
    methods: {
      ...mapActions('product', [ 'selectProducts', 'toggleBookmark', 'toggleAlarm' ]),
      ...mapMutations('home', { mutationToggleStoreBookmark:'TOGGLE_STORE_BOOKMARK' }),
      getScrollY () {
        this.scrollY = window.scrollY;
        this.bottomVisible();
      },
      select () {
        if (this.page <= this.maxPage) {
          this.selectProducts({
            status: this.status,
            page: this.page,
            second: this.time,
          }).then(response => {
            this.totalCount = response.total_count;
            this.maxPage = response.max_page;
            this.products.push(...response.data);
            this.page++;
          }).catch(err => {
            console.error(err);
          }).finally(() => {
            this.isLoading = false;
          });
        }
      },
      bookmarkProduct (idx) {
        this.toggleBookmark(idx).then(response => {
          let target = this.products.find(el => {
            return el.idx === idx;
          });
          target.bookmarks = response.data;
          this.mutationToggleStoreBookmark({ idx, flag: response.data });
          this.$forceUpdate();
        }).catch(err => {
          console.error(err);
        });
      },
      alarmProduct (idx) {
        this.toggleAlarm(idx).then(response => {
          let target = this.products.find(el => {
            return el.idx === idx;
          });
          target.alarms = response.data;
        }).catch(err => {
          console.error(err);
        });
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 100;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.toolbar-shadow {
    background-color: map-get($colors, background) !important;
    .v-toolbar__content {
      background-color: white;
      box-shadow: 0 2px 3px map-get($colors, background-shadow);
    }
  }

  // custom grid-list-md gutter settings
  /deep/.container.grid-list-md .layout:only-child {
    margin: -5px;
  }
  /deep/.container.grid-list-md .layout .flex {
    padding: 5px;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  .caption {
    color: map_get($colors, brownish-grey);
  }

  .caption-strong {
    font-weight: 700;
    color: map_get($colors, primary);
  }

  /deep/.border-color{
    .v-input__slot:before {
      border-color: map_get($colors, border) !important;
    }
    .v-input__icon--prepend .v-icon {
      color: #979797;
    }
    .v-input__icon--append .v-icon {
      color: #cdcdcd;
    }
  }

  /deep/ input {
    padding: 8px 0 2px 8px !important;
    font-size: 16px;
    letter-spacing: -0.3px;
  }
</style>
